import React from 'react'
import { InfoMessageWrapper, IconInfo, TextCallout2 } from '../../style.js'

export const ChannelInfoMessage = () => {
  return (
    <InfoMessageWrapper data-testid="channel-info-message">
      <IconInfo width={20} height={20} />
      <TextCallout2>Meddelanden äldre än ett år tas bort automatiskt.</TextCallout2>
    </InfoMessageWrapper>
  )
}

export default ChannelInfoMessage
